export const MEDIUM_TO_MEDIUM_APPOINTMENT_TYPE_OPTIONS = [
  { value: 1, label: "Practice" },
  { value: 7, label: "Professional Pay later" },
];

const EXCLUDED_DURATION_SUBSESSION_IDS = new Set([93]);

export const findSubsessionByDuration = (subsessions = [], duration) => {
  return (
    subsessions.find((item) => String(item.duration) === String(duration)) ||
    null
  );
};

// Several subsessions can share a duration (e.g. 60 min single vs 60 min for
// 2 people), so the dropdown must be keyed by subsession id, not duration.
export const findSubsessionById = (subsessions = [], id) => {
  return subsessions.find((item) => String(item.id) === String(id)) || null;
};

export const getDurationOptions = (subsessions = []) => {
  return subsessions
    .filter((item) => !EXCLUDED_DURATION_SUBSESSION_IDS.has(Number(item.id)))
    .map((item) => ({
      id: item.id,
      value: String(item.id),
      duration: item.duration,
      label: item.sub_session_name,
    }));
};
